import React from 'react';
import { ArrowUp } from 'lucide-react';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-cream border-t border-ink/10 py-12" data-id="element-87">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-88">
        <div className="text-2xl font-serif tracking-tight" data-id="element-89">
          Oli Creative<span className="text-accent" data-id="element-90">.</span>
        </div>

        <div className="flex gap-6 text-sm font-medium text-ink-light" data-id="element-91">
          <a href="#" className="hover:text-accent transition-colors" data-id="element-92">
            Instagram
          </a>
          <a href="#" className="hover:text-accent transition-colors" data-id="element-93">
            LinkedIn
          </a>
          <a href="#" className="hover:text-accent transition-colors" data-id="element-94">
            Behance
          </a>
          <a href="#" className="hover:text-accent transition-colors" data-id="element-95">
            Dribbble
          </a>
        </div>

        <div className="flex items-center gap-6" data-id="element-96">
          <p className="text-sm text-ink-light" data-id="element-97">
            © {new Date().getFullYear()} All rights reserved.
          </p>
          <button onClick={scrollToTop} className="w-10 h-10 rounded-full border border-ink/20 flex items-center justify-center hover:bg-ink hover:text-cream hover:border-ink transition-all duration-300" aria-label="Scroll to top" data-id="element-98">
            <ArrowUp size={18} data-id="element-99" />
          </button>
        </div>
      </div>
    </footer>;
}